import { Route } from 'react-router-dom';
import AuditPage from '../../pages/raptor/audit/audit.page';
import PermissionRoute from '../../guard/permission-route';

/** Solo admin/superadmin (mismo @Roles('admin') del backend). */
export const RaptorAuditRoutes = (
  <Route element={<PermissionRoute module="audit" />}>
    <Route path="/audit">
      <Route index element={<AuditPage />} />
    </Route>
  </Route>
);
